export default "__VITE_ASSET__CeUQNFYg__"